import React, { useState, useEffect } from "react";

export const SorryUser = ({
  isContestEnded = null,
  IsCorrectAns = null,
  endDateTime = "",
  isSubmitted = null,
}) => {
  const [pageLoading, setPageLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false);
    }, 800);
  }, []);
  return (
    <>
      {isSubmitted == 1 &&
        IsCorrectAns == 0 &&
        (isContestEnded == 1 || isContestEnded == 0) && (
          <>
            {pageLoading ? (
              <span className="DishKiChampionsTrophy-loader"></span>
            ) : (
              <div className="quiz-container">
                <div className="winner-container centerElement">
                  <div className="winner-header mb-0">
                    <div className="winner-icon">
                      <img src="/Images/thumbs-up.png" alt="thumbs-up" />
                    </div>
                    <h2 className="question-title mt-0 mb-2">
                      Thanks! You have already participated in this contest!
                    </h2>
                    <p>
                      Thank you for participating in our contest! Result will be
                      announced{" "}
                      {endDateTime &&
                      typeof endDateTime === "string" &&
                      endDateTime.includes(" at ")
                        ? endDateTime.split(" at ")[0]
                        : "soon"}
                      &nbsp; 11:00PM
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

      {isSubmitted == 1 && IsCorrectAns == 1 && isContestEnded == 1 && (
        <>
          {pageLoading ? (
            <span className="DishKiChampionsTrophy-loader"></span>
          ) : (
            <div className="quiz-container">
              <div
                className="winner-container centerElement"
                style={{ transform: "translate(-50%, 100%)" }}
              >
                <div className="winner-header mb-0">
                  <div className="winner-icon">
                    <img src="/Images/thumbs-up.png" alt="thumbs-up" />
                  </div>
                  <h2 className="question-title mt-0 mb-2">
                    Thanks for participating!
                  </h2>
                  <p>You have made correct prediction.</p>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {isSubmitted == 1 && IsCorrectAns == 2 && isContestEnded == 1 && (
        <>
          {pageLoading ? (
            <span className="DishKiChampionsTrophy-loader"></span>
          ) : (
            <div className="winner-container centerElement">
              <div className="winner-header mb-0">
                <div className="winner-icon">
                  <img src="/Images/try-agian.png" alt="try-agian" />
                </div>
                <h2 className="question-title mt-0 mb-2">Try Again!</h2>
                <p>
                  Sorry! your all questions prediction are wrong, Please try
                  agin later in next contest.
                </p>
              </div>
              <div>
                <h3>Thanks for Participate!</h3>
              </div>
            </div>
          )}
        </>
      )}

      {isSubmitted == 1 &&
        (IsCorrectAns == 2 || IsCorrectAns == 1) &&
        isContestEnded == 0 && (
          <>
            {pageLoading ? (
              <span className="DishKiChampionsTrophy-loader"></span>
            ) : (
              <div className="quiz-container">
                <div className="winner-container centerElement">
                  <div className="winner-header mb-0">
                    <div className="winner-icon">
                      <img src="/Images/thumbs-up.png" alt="thumbs-up" />
                    </div>
                    <h2 className="question-title mt-0 mb-2">
                      Thanks! You have already participated in this contest!
                    </h2>
                    <p>
                      Thank you for participating in our contest! Result will be
                      announced{" "}
                      {endDateTime &&
                      typeof endDateTime === "string" &&
                      endDateTime.includes(" at ")
                        ? endDateTime.split(" at ")[0]
                        : "soon"}
                      &nbsp; 11:00PM
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

      {isSubmitted == 0 && isContestEnded == 1 && (
        <>
          {pageLoading ? (
            <span className="DishKiChampionsTrophy-loader"></span>
          ) : (
            <div className="quiz-container">
              <div className="winner-container centerElement">
                <div className="winner-header mb-0">
                  <div className="winner-icon">
                    <img src="/Images/try-agian.png" alt="try-agian" />
                  </div>
                  <h2 className="question-title mt-0 mb-2">
                    Contest has ended
                  </h2>
                  <p>
                    You have not participated in this consent. Next content will
                    be starting soon.
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
